import { Component, Input } from '@angular/core';
import { IModule } from 'src/app/interfaces/IModule';
import { paths } from 'src/component-paths/component-paths';
@Component({
  selector: 'app-ips-section',
  templateUrl: './ips-section.component.html',
  styleUrls: ['./ips-section.component.css'],
  standalone: false,
})
export class IpsSectionComponent {
  @Input() submenu?: IModule[];
  componentPaths = paths;

  ngOnInit() {}
}
